// extracted by mini-css-extract-plugin
module.exports = {"container":"Legend_container__-MClc","circle":"Legend_circle__2bYmO"};